import { useState, useRef, Fragment } from 'react'
import { RiStarSFill, RiStarSLine } from 'react-icons/ri'
import { BiDollar } from 'react-icons/bi'
import { Dialog, Transition } from '@headlessui/react'

function Card({place}) {
    const cancelButtonRef = useRef(null)

    const [modalImage, setModalImage] = useState(null)
    const [modalName, setModalName] = useState(null)
    const [toggleModal, setToggleModal] = useState(false)

    return (
        <div className='p-2 m-2 rounded-lg bg-slate-300 flex flex-col'>
            <div className='flex flex-row justify-between'>
                <div className='flex flex-col'>
                <div className='w-44 truncate'>
                    {place.name}
                </div>
                <div className='flex'>
                    <div className='mx-2'>{place.rating}</div>
                    <div className='flex self-center'>
                    {[...Array(5).keys()].map((n) => (
                        <>
                            {n < (Math.round(Number(place.rating))) ?
                                <RiStarSFill key={n} size={20} />
                                : <RiStarSLine key={n} size={20} />
                            }
                        </>
                    ))}
                    </div>
                </div>

                <div className='flex  mt-1'>
                    <div className='ml-2 self-start'>
                    {place.opening_hours != null ?
                        place.opening_hours.isOpen() ? 
                            <div className='text-emerald-700'>Open</div> 
                            : 
                            <div className='text-rose-700'>Closed</div>
                            :
                            <div className='font-thin'>Unknown</div>
                    } 
                    </div>
                    <div className='flex self-center ml-5'>
                    Price:
                    <div className='flex self-center ml-1'>
                        {place.price_level > 0 ? 
                        [...Array(5).keys()].map((n) => (
                            <>
                                {n < (place.price_level) ?
                                    <BiDollar className='text-emerald-700' key={n} size={20} />
                                    : <></>
                                }
                            </>
                        )) 
                        :
                        <div className='font-fredokaLight'>Unknown</div>
                    }
                    </div>
                    </div>
                </div>
                <div className='ml-2'>
                    {place.vicinity}
                </div>
                <div className='ml-2'>
                    {place.index}
                </div>
                </div>
                <div onClick={() => {
                    setToggleModal(true)
                    setModalImage(place.photos[0].getUrl())
                    setModalName(place.name)
                }}
                >
                {place.photos && <img className='object-cover h-24 w-24 rounded-xl p-1 hover:cursor-pointer' src={place.photos[0].getUrl()}/>}
                </div>
                <Transition.Root show={toggleModal} as={Fragment} onClick={() => {setToggleModal(false)}}>
                <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" initialFocus={cancelButtonRef} onClose={setToggleModal}>
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-5 transition-opacity" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:align-middle sm:max-w-lg sm:w-full">
                        <div className="bg-white p-4">
                            <div className="sm:flex sm:items-start">
                            <div className="text-center">
                                <Dialog.Title as="h3" className="text-lg leading-6 font-fredokaMedium mb-2 text-gray-900">
                                Images for {modalName}
                                </Dialog.Title>
                                <img 
                                    ref={cancelButtonRef} 
                                    className='rounded-lg' 
                                    src={modalImage}
                                />
                            </div>
                            </div>
                        </div>
                        </div>
                    </Transition.Child>
                    </div>
                </Dialog>
                </Transition.Root>
            </div>
        </div>
    )
}

export default Card